const maximumCheckDelay = 60_000;
const minimumCheckDelay = 50;

class TafPromotionWindow extends HTMLElement {
  connectedCallback() {
    this.stopTimer();
    this.startTime = Number(this.dataset.startSeconds) * 1000;
    this.endTime = Number(this.dataset.endSeconds) * 1000;
    const serverTime = Number(this.dataset.serverSeconds) * 1000;
    this.serverActive = this.dataset.serverActive === 'true';
    this.stateChangeRequested = false;

    if (
      !Number.isFinite(this.startTime) ||
      !Number.isFinite(this.endTime) ||
      !Number.isFinite(serverTime) ||
      this.endTime <= this.startTime
    )
      return;

    this.clockOffset = serverTime - Date.now();
    this.handlePageShow = () => this.checkWindow();
    this.handleVisibilityChange = () => {
      if (!document.hidden) this.checkWindow();
    };
    window.addEventListener('pageshow', this.handlePageShow);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.checkWindow();
  }

  disconnectedCallback() {
    this.stopTimer();
    if (this.handlePageShow) window.removeEventListener('pageshow', this.handlePageShow);
    if (this.handleVisibilityChange) document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  stopTimer() {
    if (!this.timer) return;
    window.clearTimeout(this.timer);
    this.timer = null;
  }

  checkWindow() {
    this.stopTimer();
    const now = Date.now() + this.clockOffset;
    const active = now >= this.startTime && now < this.endTime;

    if (active !== this.serverActive) {
      if (this.stateChangeRequested) return;
      this.stateChangeRequested = true;
      const stateChange = new CustomEvent('taf-promotion-state-change', {
        bubbles: true,
        cancelable: true,
        detail: {active},
      });
      if (this.dispatchEvent(stateChange)) window.location.reload();
      return;
    }

    let boundary = null;
    if (now < this.startTime) boundary = this.startTime;
    else if (active) boundary = this.endTime;
    if (boundary === null) return;

    const delay = Math.min(Math.max(boundary - now, minimumCheckDelay), maximumCheckDelay);
    this.timer = window.setTimeout(() => this.checkWindow(), delay);
  }
}

if (!customElements.get('taf-promotion-window')) {
  customElements.define('taf-promotion-window', TafPromotionWindow);
}
